module.exports = __webpack_public_path__ + "static/media/discord.98046c7c.PNG";